import * as R from 'Router/routes';
import { ClientBlockedStatusState } from 'hooks/webapi/useClientBlockedStatus';
import { ERROR_LOGIN_MESSAGE_QUERY_PARAM } from '../customAnalytics/constants';
import { getSearchString } from 'utils/index';
import { LatestLoan } from 'hooks/webapi/useLatestLoan';
import { LoanType } from 'hooks/useRepeatedLoanNavigation';
import { PRODUCT_NUMBER_ONLINE, PRODUCT_NUMBER_PARAM } from 'utils/constants';
/* eslint-disable no-console */
export function isEnvSwitcherEnabled(env: string) {
  return ['at1', 'demo', 'local'].includes(env);
}

export function getSelectedDevEnv(): string {
  return (
    localStorage.getItem('qaSelectedEnv') ??
    (import.meta.env.VITE_DEFAULT_API_ENV as string) ??
    'stage'
  );
}

type UrlType =
  | 'WEB_API'
  | 'COLA_URL'
  | 'STATIC_HOMEPAGE'
  | 'STATIC_61_HOMEPAGE'
  | 'VIVUS_REGISTRATION_URL'
  | 'VIVUSONLINE_REGISTRATION_URL';

export function getProcessEnvUrl(url: UrlType) {
  const fallback = import.meta.env[`VITE_${url}`];

  if (!isEnvSwitcherEnabled(import.meta.env.VITE_ENV ?? '')) {
    return fallback;
  }

  const selectedDevEnv = getSelectedDevEnv().toUpperCase().replace(/-/g, '_');

  const found = import.meta.env[`VITE_${selectedDevEnv}_${url}`];

  if (!found) {
    console.error(`import.meta.env.VITE_${selectedDevEnv}_${url} not found.`);
  }

  return found ?? fallback;
}

export function getClearUrlQueryString() {
  const urlParams = new URLSearchParams(
    decodeURIComponent(window.location.search),
  );
  urlParams.delete(ERROR_LOGIN_MESSAGE_QUERY_PARAM);
  urlParams.delete('redirect');
  urlParams.delete('cons');

  const paramsString = urlParams && urlParams.toString();

  if (paramsString) {
    return decodeURIComponent(`?${paramsString}`);
  }

  return '';
}

const isProduct6Login = () =>
  sessionStorage.getItem(PRODUCT_NUMBER_PARAM) === PRODUCT_NUMBER_ONLINE;

export const getLoginUrl = () => (isProduct6Login() ? R.ONLINE_LOGIN : R.LOGIN);

export const getCalculatorUrl = () =>
  isProduct6Login()
    ? getProcessEnvUrl('STATIC_61_HOMEPAGE')
    : getProcessEnvUrl('STATIC_HOMEPAGE');

export const getFinalRepeatedLoanScreen = (
  typeOfLoan: 'MAIN' | 'ADDITIONAL',
) => {
  return typeOfLoan === 'MAIN'
    ? R.LOAN_CHECK_DETAILS
    : R.ADDITIONAL_AMOUNT_CHECK_DETAILS;
};

// REJECTED / BLOCKED SCREEN
type RejectedScreenProps = {
  clientBlockedStatus: ClientBlockedStatusState;
  typeOfLoan?: LoanType;
  productNumber?: string;
  latestLoan?: LatestLoan | null | undefined;
};
export const getRejectedScreen = ({
  clientBlockedStatus,
  typeOfLoan = 'MAIN',
  productNumber,
  latestLoan,
}: RejectedScreenProps) => {
  if (clientBlockedStatus?.blocked && !latestLoan) return R.REJECTED_TIMER_FLOW;

  const productNumberQueryParam = productNumber
    ? getClearUrlQueryString() + getSearchString(productNumber)
    : '';

  const route =
    typeOfLoan === 'MAIN'
      ? R.LOAN_REJECTED + productNumberQueryParam
      : R.ADDITIONAL_AMOUNT_REJECTED;

  return route;
};
